import { Case } from "./types.js";
export const isObject = (o) => o === Object(o) && !Array.isArray(o) && typeof o !== "function";
export const toCamelCase = (s) => s.replace(/(_[a-z])/gi, ($1) => $1.toUpperCase().replace("_", ""));
export const toSnakeCase = (str) => str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
export const caseTransfer = (o, type) => {
  if (isObject(o)) {
    const n = {};
    Object.entries(o).forEach(([k, v]) => {
      n[(type === Case.CAMEL ? toCamelCase : toSnakeCase)(k)] = caseTransfer(v, type);
    });
    return n;
  }
  if (Array.isArray(o)) {
    return o.map((i) => caseTransfer(i, type));
  }
  return o;
};
